import React from 'react';
import SelectField from '../../../../../../web-app-components/components/SelectField';
import MenuItem from '@material-ui/core/MenuItem';

const TRAVEL_METHODS = [
  { value: 'pėsčiomis', label: 'Pėsčiomis' },
  { value: 'dviračiu', label: 'Dviračiu' },
  { value: 'automobiliu', label: 'Automobiliu' },
  { value: 'visureigiu', label: 'Visureigiu' },
  { value: 'Street', label: 'Street' },
  { value: 'Enduro', label: 'Enduro' },
];

const TravelMethodSelectField = (props) => {
  return (
    <SelectField {...props}>
      {TRAVEL_METHODS.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default TravelMethodSelectField;
